import styled from "styled-components";

export const Container = styled.div`
  font-family: Sora;
  position: relative;
  user-select: none;
  display: flex;
`;

export const Content = styled.div`
  background: ${({ open }) => (open ? "#42464c" : "#585e66")};
  color: #f4f4f4;

  width: 8.5625rem;
  height: 2.6875rem;

  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  margin-right: 0.905rem;

  border-radius: 0.35296625rem;
  font-weight: bold;

  &:hover {
    background: #42464c;
  }

  cursor: pointer;
  svg {
    height: 0.9375rem;
  }

  span {
    font-family: Sora;
    margin-left: 0.43125rem;
    font-size: 0.7062rem;
  }
`;

export const DropMenu = styled.div`
  position: absolute;
  display: flex;
  background: #42464c;
  flex-direction: column;
  transform: translate(-3.3rem, 2.9rem);
  border: 1.12585px solid #d4d6da;
  box-shadow: 0px 0.234551rem 0.3516rem rgba(45, 48, 51, 0.18);
  border-radius: 0.3516rem;
`;

export const MainOption = styled.div`
  display: flex;
  color: #a9aeb4;
  font-size: 0.7083rem;
  margin-top: 0.66rem;
  margin-bottom: 0.44rem;
  padding: 0.2345rem 0 0.2345rem 0.88rem;
  cursor: pointer;

  &:hover {
    background: #212326;
    color: #eff1f5;
  }
`;

export const Line = styled.div`
  width: 100%;
  height: 0.1px;
  background: #585e66;
`;
export const UList = styled.ul`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  width: 11.9rem;
  color: #a9aeb4;
  font-size: 0.7083rem;
  cursor: pointer;
  padding: 0.2345rem 0 0.2345rem 0.88rem;
  justify-content: space-between;
  margin-bottom: 0.3rem;
  &:first-child {
    margin-top: 0.55rem;
  }

  svg {
    margin-right: 0.820833333rem;
  }

  &:hover {
    background: #212326;
    color: #eff1f5;

    path {
      fill: #eff1f5;
    }
  }
`;
